import {useEffect, useState} from "react";
import {
    setPreferredReader,
    useStripeTerminal,
} from "@/components/Providers/StripeTerminalProvider.tsx";
import {isInFileMaker} from "@/utils/fmScripts.ts";

const useFMLogin = () => {
    const [inFileMaker, setInFileMaker] = useState<boolean>(false);
    const {readers, connectReader} = useStripeTerminal();

    useEffect(() => {
        isInFileMaker.then(setInFileMaker);

        if (window.location.hash) {
            const searchUrl = new URLSearchParams(window.location.hash.replace("#", ""));
            const readerId = searchUrl.get("readerId");
            if (readerId) {
                setPreferredReader(readerId);
                const reader = readers.find(r => r.id === readerId);
                if (connectReader && reader) {
                    connectReader(reader).catch(e => {
                        console.error("error setting reader", e);
                    });
                }
            }
        }
    }, []);

    useEffect(() => {
        if (!inFileMaker) {
            return;
        }
        if (window.FileMaker?.PerformScript) {
            window.FileMaker.PerformScript("WebViewer | React Login Ready", "");
            console.info("called WebViewer | React Login Ready");
        }
    }, [inFileMaker]);
    return {inFileMaker};
};

export default useFMLogin;
